/* eslint-disable @typescript-eslint/no-explicit-any */
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {notificationsApiClient} from '#lib/api-client';
import {queryKeys} from '#lib/query-client';
import {
  getNotificationsResponseTransformer,
  getNotificationByIdResponseTransformer
} from '#utils/response-transformers/notifications';
import {STALE_TIME, GC_TIME} from '#constants';

// Hook for fetching notifications list
export function useNotifications(
  params: {
    limit?: number;
    pageNumber?: number;
    search?: string;
    sortBy?: string;
    sortType?: string;
  } = {},
  options?: Omit<UseQueryOptions<any>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: [...queryKeys.notifications.list(params)],
    queryFn: async () => {
      const response = await notificationsApiClient.getNotifications(params);
      return getNotificationsResponseTransformer(response as any);
    },
    staleTime: STALE_TIME.NOTIFICATIONS,
    gcTime: GC_TIME.NOTIFICATIONS,
    ...options
  });
}

// Hook for fetching notification by ID
export function useNotificationById(
  id: string | number,
  options?: Omit<UseQueryOptions<any>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: queryKeys.notifications.detail(id),
    queryFn: async () => {
      const response = await notificationsApiClient.getNotificationById(id);
      return getNotificationByIdResponseTransformer(response as any);
    },
    staleTime: STALE_TIME.NOTIFICATIONS_DETAIL,
    gcTime: GC_TIME.NOTIFICATIONS,
    enabled: !!id,
    ...options
  });
}

export function useUnreadNotificationExists(
  options?: Omit<UseQueryOptions<any>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: queryKeys.notifications.unreadExists(),
    queryFn: async () => {
      const response =
        await notificationsApiClient.getUnreadNotificationExists();
      return response;
    },
    staleTime: STALE_TIME.NOTIFICATIONS_DETAIL,
    gcTime: GC_TIME.NOTIFICATIONS,
    ...options
  });
}
